<template>
    <md-input :value="formattedValue"
              :required="required"
              :disabled="disabled"
              @focusin="onFocusStart"
              @focusout="onFocusEnd"
              @input="onInput"
              v-currency="options"
              :key="requireForcedUpdate"
    ></md-input>
</template>

<script>
import {CurrencyDirective} from "vue-currency-input";
import {localization} from "@/common/lang/localization";
import {formatAsMoneyAmount, formatAsMoneyAmountForAPI} from "@/common/format";

export default {
	props: {
	    value: { type: Number | null, default: null },
        currency: { type: String,  default: null },
        decimals: { type: Number,  default: 2 },
        formatDuringInput: { type: Boolean, default: true },
        allowNegativeValues: { type: Boolean, default: false },
        required: { type: Boolean, default: false },
        disabled: { type: Boolean, default: false },
        clearZeroOnFocus: { type: Boolean, default: true },
		asPercentageRate: { type: Boolean, default: false }
    },
	directives: {
		currency: CurrencyDirective
    },
    data() {
	    return {
	    	formattedValue: "",
	    	options: {
				locale: this.getLocale(),
				currency: this.currency,
				distractionFree: {
					hideNegligibleDecimalDigits: true,
					hideCurrencySymbol: true,
					hideGroupingSymbol: !this.formatDuringInput
				},
				precision: this.decimals,
				allowNegative: this.allowNegativeValues
			},
            defaultIsZero: this.isValueZero(),
            isFocused: false,
            requireForcedUpdate: 0,
        }
    },
    beforeMount() {
        this.updateFormattedValue(this.value);
	},
    watch: {
        value() {
			if (!this.isFocused) {
			    this.updateFormattedValue(this.value);
			}
		}
    },
    methods: {
		getLocale() {
			return localization.currentLocale();
		},
		onFocusStart() {
			this.isFocused = true;

			if (this.clearZeroOnFocus && this.defaultIsZero && this.isValueZero()) {
				this.updateFormattedValue(null)
            }
            this.$emit("focusStart")
        },
        onFocusEnd() {
			this.isFocused = false;

			if (this.clearZeroOnFocus && this.defaultIsZero && !this.isValueSet()) {
                this.updateFormattedValue(0);
            }
        },
		onInput(newValue /* as localized string format */) {
			// first convert to number format
			let unformattedValue = formatAsMoneyAmountForAPI(newValue);

			// adjust for percentage display
			if (unformattedValue && this.asPercentageRate) {
				unformattedValue = parseFloat(Number(unformattedValue / 100).toFixed(this.decimals + 2));
			}

			this.$emit("input", unformattedValue);
        },
        isValueSet() {
		    return this.value !== undefined && this.value !== null;
        },
        isValueZero() {
			return this.isValueSet() && this.value === 0;
        },
        updateFormattedValue(newValue /* as number format */) {
		    // When we manually update the value we need to do the formatting ourselves,
            // otherwise some values can be misread like "11.23" with german locale is read as "1123,00"
			let formattedValue = newValue;

			// adjust for percentage display
			if (formattedValue && this.asPercentageRate) {
				formattedValue = formattedValue * 100;
			}

	        this.formattedValue = formatAsMoneyAmount(formattedValue, {decimals: this.decimals});

            // Sometimes we need to force an update of the component when the value changed while it is not in focus
            // because Vue does not recognize it automatically.
            // By changing key value of the component it is forced to update.
		    if (!this.isFocused) {
                this.requireForcedUpdate++;
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>